import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { StarFormation } from './star/StarFormation';
import PropTypes from 'prop-types';
import { loadThreads, getChatHistorybyOrgUser } from '../utils/botFactoryAPI';
import { buildContactEmail, contactEmailFailureText, pickAgentId } from '../utils/contactEmail';
//import { joinZoomMeeting } from '../utils/joinZoomMeeting.tsx_';
import ReactDOMServer from 'react-dom/server';
import { WavRecorder, WavStreamPlayer } from '../lib/wavtools/index.js';
//Heroicons
import * as HeroSolid from '@heroicons/react/24/solid';
import * as HeroOutline from '@heroicons/react/24/outline';


// ⛔ REACT_APP_-prefixed or it is dead: CRA inlines nothing else. `EMAIL_BASE_URL` was
// never reaching the bundle, so v2 has been emailing through the LEGACY api all along —
// silent, because a working legacy endpoint looks exactly like success.
const EMAIL_BASE_URL =
  process.env.REACT_APP_EMAIL_BASE_URL ||
  'https://robot-api-37f87b97b291.herokuapp.com';

//const PAGE_TIMEOUT = 900;//Timeout 15 min in seconds, 120 = 2 minutes - 
const PROMPT_BUTTON_MAX = 12;// max number of prompt buttons
const THREAD_LIMIT = 5;//Conversation History
//const HEARTBEAT_PING = 10000 // millis: 120000 = 2 mins DEPR - See IndexPage

let filteredText ="";//emailed content is filtered
let filteredHTML =""; 

//Get user
  const storedUser =localStorage.getItem("user");
  const user = storedUser && storedUser !== "null" ? JSON.parse(storedUser) : { 
    id: "guest",
    username: "guest",
    email: "",
    firstname: "Guest",
    lastname: "User",
    emailVerified: false,
    verificationToken: "",
    role: "guest",
    mobile: "",
    pic: "",
    system: false,
  };

/* GET ORG SETTINGS */
let settings = null;
try {
  const orgCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('org='))
    ?.split('=')[1];

  if (orgCookie) {
    settings = JSON.parse(decodeURIComponent(orgCookie));
  }
} catch (err) {
  console.warn('❌ Failed to parse settings from org cookie:', err);
}


const ChatUIWhite = ({
  Header,
  Footer,
  iBots,
  assistantId,
  isConnected,
  timeLeft,
  connectConversation,
  setTimeLeft,
  sendTextQuery,
  isRecording,
  startRecording,
  stopRecording,
  clientCanvasRef,
  serverCanvasRef,
  items,
  setItems,
  clientRef,
  iBookThumbnail,
  showEventsLog,
  setShowEventsLog,
  eventsScrollRef,
  realtimeEvents,
  botSettings = null,
  selectedBot,
  clearSession,
  toggleMute = () => {},
  isMuted = false,
  emitStandbyLine = () => {},
  onPromptClicked = (_prompt) => {},
  onUserQuestion = (_message) => {},
  onSessionCleared = (_reason) => {},
  onLanguageCommand = (_lang) => {},

}) => {
  const userInputRef = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [emailSubject, setEmailSubject] = useState("Conversation Content");
  const [emailBody, setEmailBody] = useState("");
  const [emailFrom, setEmailFrom] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [emailFromName, setEmailFromName] = useState(""); 
  const [emailToName, setEmailToName] = useState(""); 
  const [emailBodyHTML, setEmailBodyHTML] = useState("");// Email editing
  const [videoModalSrc, setVideoModalSrc] = useState(null);
  const [videoModalTitle, setVideoModalTitle] = useState('');

  // image icons
  const copyIconWhite = "/assets/app/copy-white.png"
  const storeIconWhite = "/assets/app/stop-white.png"
  const trashIconWhite = "/assets/app/trash-white.png"
  const emailIconBlack = "/assets/app/email-black.png"
  const emailIconWhite = "/assets/app/email-white.png"
  const micIconWhite = "/assets/app/mic-white.png"
  const micIconRed = "/assets/app/mic-red.png"
  const enterIconWhite = "/assets/app/text-white.png"
  // Preserve original default icon; muted state uses alternate art
  const stopIconDefault = "/assets/app/mute-speaker-white.png";
  const stopIconMuted = "/assets/app/mute-speaker-black.png";
  const stopButtonIcon = isMuted ? stopIconDefault : stopIconMuted;
 
  //Stop bot Speech on Video Render
  const stopSentRef = useRef(false);

  //const [showThreads, setShowThreads] = useState(false);

  //const renderedMediaKeys = new Set();   // ✅ Track [Media] keys globally to force single render

  let userInLineName = null;
  const notifySessionCleared = (reason = 'user_stop') => {
    if (typeof onSessionCleared === 'function' && onSessionCleared !== clearSession) {
      onSessionCleared(reason);
    }
  };

  const defaultBotSettings = useMemo(() => ({
    integration: {
      EmailConfig: {
        from_email: '',
        from_name: '',
        to_email: '',
        to_name: '',
        emailMessage: ''
      },
    },
    creator: { name: '', url: '' },
    logo: '',
    containerStyle: {
      copyContentButton: 'false',
      deleteContentButton: 'false',
      emailContentButton: 'false',
    },
  }), []);

  const [selectedBotSettings, setSelectedBotSettings] = useState(defaultBotSettings);
  const [threadOffset, setThreadOffset] = useState(0);

  useEffect(() => {
    const mergeWithDefaults = (settings = {}) => {
      const integration = {
        ...defaultBotSettings.integration,
        ...(settings.integration || {}),
        EmailConfig: {
          ...defaultBotSettings.integration.EmailConfig,
          ...(settings.integration && settings.integration.EmailConfig ? settings.integration.EmailConfig : {}),
        },
      };

      return {
        ...defaultBotSettings,
        ...settings,
        integration,
        creator: {
          ...defaultBotSettings.creator,
          ...(settings.creator || {}),
        },
        containerStyle: {
          ...defaultBotSettings.containerStyle,
          ...(settings.containerStyle || {}),
        },
      };
    };

    const ensureMatch = (settings) => {
      if (!settings) return null;
      const candidate = mergeWithDefaults(settings);
      if (!selectedBot?.botid) return candidate;
      return candidate.botid === selectedBot.botid ? candidate : null;
    };

    let resolved = ensureMatch(botSettings);

    if (!resolved) {
      try {
        const stored = localStorage.getItem('botSettings');
        if (stored) {
          resolved = ensureMatch(JSON.parse(stored));
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to parse bot settings from storage:', err);
      }
    }

    if (!resolved) {
      try {
        const cookieValue = document.cookie
          .split('; ')
          .find((row) => row.startsWith('botSettings='))
          ?.split('=')[1];
        if (cookieValue) {
          resolved = ensureMatch(JSON.parse(decodeURIComponent(cookieValue)));
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to parse bot settings from cookie:', err);
      }
    }

    if (!resolved && selectedBot?.integration?.EmailConfig) {
      resolved = mergeWithDefaults({
        botid: selectedBot.botid,
        name: selectedBot.title || '',
        logo: selectedBot.thumbnail || defaultBotSettings.logo,
        integration: {
          EmailConfig: {
            ...selectedBot.integration.EmailConfig,
          },
        },
        containerStyle: selectedBot.settings?.containerStyle || {},
      });
    } else if (!resolved && selectedBot) {
      resolved = mergeWithDefaults({
        botid: selectedBot.botid,
        name: selectedBot.title || '',
        logo: selectedBot.thumbnail || defaultBotSettings.logo,
        containerStyle: selectedBot.settings?.containerStyle || {},
      });
    }

    if (!resolved) {
      resolved = defaultBotSettings;
    }

    setSelectedBotSettings((prev) => {
      try {
        const prevString = JSON.stringify(prev);
        const nextString = JSON.stringify(resolved);
        if (prevString === nextString) {
          return prev;
        }
      } catch (err) {
        console.warn('[ChatUI] Failed to compare bot settings:', err);
      }
      return resolved;
    });
  }, [botSettings, selectedBot, defaultBotSettings]);

  useEffect(() => {
    if (selectedBotSettings) {
      console.log('Bot Settings:', selectedBotSettings);
    }
  }, [selectedBotSettings?.botid]);

  const handleManualTextSend = useCallback(() => {
    const inputElement =
      (userInputRef && userInputRef.current) ||
      document.getElementById('user-input');

    if (!inputElement) return;

    const userInput = inputElement.value.trim();
    if (!userInput) return;

    if (userInput.toLowerCase() === 'stop') {
      emitStandbyLine();
      inputElement.value = '';
      return;
    }

    if (tryHandleVideoModalMedia(userInput)) {
      inputElement.value = '';
      return;
    }

    sendTextQuery(userInput);
    inputElement.value = '';
  }, [emitStandbyLine, sendTextQuery]);
  const [threads, setThreads] = useState(null);// Threads list from botFactory API
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const handleLoadThreads = async () => {
    setLoading(true);
    setError(null);

    const user = JSON.parse(localStorage.getItem("user"));
    const offset = threadOffset;
    const token = document.cookie
              .split('; ')
              .find(row => row.startsWith('token='))
              ?.split('=')[1]; // Retrieve token value
    console.log('Token:', token); // Log token to confirm

    if (!token && user) {
      setError("[handleLoadThreads] - ChatWhiteUI -User /u token missing -auth token not found.");
      setLoading(false);
      return;
    }
    try {
      const data = await loadThreads(user.id, token, offset, THREAD_LIMIT);
      setThreads(data);
      setThreadOffset(offset);
    } catch (err) {
      setError(err.message);
    } finally {
    setLoading(false);
  }
};

  const handleEmailCloseModal = async () => {
    setShowEmailModal(false);
    await handleResumeClick(); // Reinstate bot session
  };

  // State for Category and Sub-Category and Cards
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const videoContainerRef = useRef(null); 
  let selectedPrompt = null;

  const tryHandleVideoModalMedia = (text) => {
    if (!text || !selectedBot?.media) return false;

    const mediaKeys = Object.keys(selectedBot.media);
    const matchKey = mediaKeys.find((key) => {
      const media = selectedBot.media[key];
      const metadata = media?.metadata || '';
      const metadataHasModal = /(?:^|;)\s*modal\s*=\s*true\s*(?:;|$)/i.test(metadata);
      const openInModal = String(media?.modal || '').toLowerCase() === 'true' || metadataHasModal;

      return (
        media?.type === 'video' &&
        openInModal &&
        text.toLowerCase().includes(key.toLowerCase())
      );
    });

    if (!matchKey) return false;

    const media = selectedBot.media[matchKey];
    const mediaSrc = media?.src || '';
    if (!mediaSrc) return false;

    const titleMatch = String(media?.metadata || '').match(/(?:^|;)\s*title\s*=\s*['"]?([^;'"]+)['"]?\s*(?:;|$)/i);
    const title = titleMatch?.[1] || matchKey;

    setVideoModalSrc(mediaSrc);
    setVideoModalTitle(title);
    return true;
  };

  const copyConversationContent = () => {
    const conversationElement = document.querySelector('.conversation');
    if (conversationElement) {
      const content = conversationElement.innerHTML; // Get HTML content
      console.log('Copying content:', content);

      // Copy content to the clipboard
      const textToCopy = conversationElement.innerText || ''; // Convert HTML to plain text
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          alert('Conversation copied to clipboard!');
        })
        .catch((error) => {
          console.error('Failed to copy content to clipboard:', error);
        });

    } else {
      console.error('Conversation element not found!');
    }
  };

  const openEmailModal = () => {
       
      handleStopClick(); // ✅ Stop bot session BEFORE opening modal
      //client.close(); !! nope
      //const conversationElement = document.getElementById('conversation');

      const source = document.getElementById("conversation");
        if (!source) {
          alert("Conversation not found.");
          return;
        }

      const clone = source.cloneNode(true);
    
      //Filter and Remove content
      const findStop = clone.querySelector("div.chat-text-item").textContent
      if(findStop === 'stop') findStop.remove();

      const firstDiv = clone.querySelector("div:nth-child(1)");
      if (firstDiv) firstDiv.remove();
   
      const secondDiv = clone.querySelector("div:nth-child(1)");
      if (secondDiv) secondDiv.remove();

      //Hide controls
      document.getElementById("input-area").style.display = "none";

      filteredText = clone.innerText.trim();
      
      if (filteredText ==='') {
        try {
          sessionStorage.setItem('metricsHold', '1');
          setTimeout(() => sessionStorage.removeItem('metricsHold'), 5000);
        } catch (err) {
          // ignore
        }
        alert("Conversation is empty. Cannot send an empty email.");
        return;
      }
      
      filteredHTML =  clone.innerHTML;
      console.log('Email filtered text set');
      
      setEmailErrorMessage(""); // Clear any previous email errors
    
      console.log("🔍 Debug: Checking User Email Before Escaping:",emailFrom);
      const escapedEmail = encodeURIComponent(emailFrom); // ✅ Escape special characters
      console.log("✅ Debug: Escaped Email:", escapedEmail);

      setEmailFrom({escapedEmail});// 
      console.log(escapedEmail);
     
      setEmailBody(clone.innerText || ""); // Populate email body with conversation

      setEmailTo("");
      const timestamp = new Date().toLocaleString();
      
      setEmailSubject(`Lead From ${selectedBot.orgs[0].name} - ${selectedBot.title} Conversation with ${user.firstname || userInLineName }  - ${timestamp}`);
      
      console.log("✅  Email Modal Opened, showEmailModal:", showEmailModal);
      setShowEmailModal(true); // Open the email modal
    };

  const sendEmailContent = async () => {
  try {
    // 1️⃣ Basic Field Extraction
    const emailFrom = document.getElementById("emailFrom").value.trim();
    const emailFromName = document.getElementById("emailFromName").value.trim();
    const emailSubject = document.getElementById("emailSubject").value.trim();

    // 2️⃣ Get the editable “Your Message” box content
    const messageBox = document.querySelector('#emailBody div[contenteditable=\"true\"]');
    const userMessage = messageBox ? messageBox.innerText.trim() : "";

    // 3️⃣ v2.07: botapi picks the recipient and sender from the bot's settings, so the request carries
    // only these six plain-text fields (anything else is a 422). See utils/contactEmail.js.
    const built = buildContactEmail({
      agentId: pickAgentId(selectedBot?.agentId, selectedBot?.id, selectedBot?.botid, assistantId),
      visitorName: emailFromName,
      visitorEmail: emailFrom,
      subject: emailSubject,
      message: userMessage,
      transcript: filteredText,
    });
    if (!built.ok) return alert(built.error);
    const emailData = built.payload;

    console.log("📩 Sending Email Data:", emailData);

    // 4️⃣ Stop all bot activity per MSCB STOP rule
    handleStopClick();

    // 5️⃣ Send via your API endpoint
    const response = await fetch(EMAIL_BASE_URL + "/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(emailData),
    });

    if (response.ok) {
      alert("✅ - Email sent successfully!");
      localStorage.removeItem("draftEmailMessage");
      handleEmailCloseModal();
    } else {
      const errText = await response.text();
      console.error("❌ Email failed:", response.status, errText);
      alert(contactEmailFailureText(response.status) || "Failed to send email.");
    }
  } catch (error) {
    console.error("❌ - Error sending email:", error);
    alert("An error occurred while sending the email.");
  }
};


   

   const loadRun = async () => {
    console.log('🔚 - [loadRun] - Load a Run');
    
  };

  //Handle Instant Stop
 const handleStopClick = async () => {

  const client = clientRef?.current;
  localStorage.setItem("clientRef", client);

  console.log(' ✅ Stop Client ref: ',client);
  if (!client) {
    console.warn('❌ [STOP] clientRef is not initialized.');
    return;
  }

  console.log('🛑 - End Session: Create.run');

  if (client.connectionState !== 'connected') {
    console.warn('[STOP] WebSocket not connected. Attempting reconnect...');
    try {
      await client.connect();
      console.log('[STOP] WebSocket reconnected.');
    } catch (err) {
      console.warn('[STOP] Reconnect failed:', err.message);
    }
  }

  try {
    client.cancelResponse(); 
    client.sendUserMessageContent([{ type: 'input_text', text: 'stop' }]);
    //client.cancelResponse(); 
    console.log('✅ [CHATUI STOP] STOP message sent.');

    // 🔁 GLOBAL Ping Reset (in IndexPage.tsx)
    if (typeof window.resetPingTimer === 'function') {
      window.resetPingTimer();
      console.log('🔄 [CHATUI][Ping] Global Ping Reset called.');
    }

    if (typeof clearSession === 'function') {
      await clearSession();
    }

    notifySessionCleared('user_stop');

  } catch (err) {
    const errorMsg = err.message;
    const msg = 'Internet Connection Lost. Please try to reload your browser '+ errorMsg;
    alert(msg);
    console.log(msg, errorMsg)
  }
};


  const formatLinks = (text) => {
    return text.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
  };

// Handle Resume (reinstate bot session)
const handleResumeClick = async () => {
  const client = clientRef?.current;

  if (!client) {
    console.warn('❌ [RESUME] clientRef not available.');
    return;
  }

  try {
    if (client.connectionState !== 'connected') {
      console.log('[RESUME] WebSocket not connected. Reconnecting...');
      await client.connect();
      console.log('✅ [RESUME] WebSocket reconnected.');
    }

    // Send a "resume" or welcome message to restart flow
    client.sendUserMessageContent([{ type: 'input_text', text: 'resume' }]);
    console.log('✅ [CHATUI RESUME] Resume message sent.');

  } catch (err) {
    console.warn('❌ [CHATUI RESUME] Failed to reinstate session:', err.message);
  }
};



useEffect(() => {// Focus User Input
    if (userInputRef.current) {
      userInputRef.current.focus(); // Focus on the user-input element
    }
  }, []);

    // ✅ DEPR CHAT UI Ping timer to keep WebSocket alive
   /* useEffect(() => {
      const client = clientRef.current;

      const pingInterval = setInterval(() => {
        if (client && client.isConnected()) {
          try {
            client.sendUserMessageContent([
              { type: 'input_text', text: '...' } // 🔄 Heartbeat
            ]);
            console.log('📡 [Ping] Sent heartbeat ping from ChatUIWhite');
          } catch (err) {
            console.warn('⚠️ Ping failed:', err);
          }
        }
      }, 120000); // Every 2 minutes

      return () => clearInterval(pingInterval);
    }, []);
    */


  return (
    <div id="root" data-component="ChatUI">
      {videoModalSrc && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
          }}
          role="dialog"
          aria-modal="true"
        >
          <div
            style={{
              position: 'relative',
              width: '80vw',
              height: '80vh',
              background: '#fff',
              borderRadius: '10px',
              overflow: 'hidden',
              boxShadow: '0 10px 40px rgba(0,0,0,0.35)',
            }}
          >
            <button
              onClick={() => {
                setVideoModalSrc(null);
                setVideoModalTitle('');
              }}
              aria-label="Close Video"
              style={{
                position: 'absolute',
                top: '1px',
                right: '14px',
                fontSize: '28px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: 'blue',
                zIndex: 10,
              }}
            >
              ×
            </button>
            <div style={{ padding: '10px 14px 0 14px', fontWeight: 600 }}>{videoModalTitle}</div>
            <iframe
              src={videoModalSrc}
              title={videoModalTitle || 'Video'}
              style={{ width: '100%', height: 'calc(100% - 42px)', border: 'none' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
      <Header />
      <main style={{ backgroundColor: settings?.containerStyle?.backgroundColor || 'white' }}>

        <div className="chat-container" style={{ backgroundColor: settings?.containerStyle?.backgroundColor || 'white' }}>

          <div className="bot-avatar"></div>
          <div className="bot-container">
            <h1 
            id="botTitle"
            style={{color:'black'}}
            >
              {(() => {
                if (assistantId && iBots.length > 0) {
                  selectedBot = iBots
                    .flatMap((group) => group.iBots)
                    .find((bot) => bot.botid === assistantId);

                  if (selectedBot) {
                    return selectedBot.title;
                  }

                  console.warn('No matching bot found for assistantId:', assistantId);
                  return 'Bot not found';
                }
                return 'Loading...';
              })()}
            </h1>

            <div className="dropdowns-container" style={{ textAlign: 'center', marginBottom: '20px' }}></div>
            {selectedBot?.ontology && Object.keys(selectedBot.ontology).length > 0 && (
              <div className="dropdowns-container" style={{ textAlign: 'center', marginBottom: '20px' }}>
                {/* Category Dropdown */}
                <select
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                    setSelectedSubCategory(''); // Reset Sub-Category when Category changes
                  }}
                  style={{ marginRight: '10px', padding: '5px' }}
                >
                  <option value="" disabled>
                    Select Category
                  </option>
                  {/* Dynamically populate categories */}
                  {Object.keys(selectedBot.ontology).map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </select>

                {/* Sub-Category Drop-down */}
                <select
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                  disabled={!selectedCategory} // Disable until Category is selected
                  style={{ padding: '5px' }}
                >
                  <option value="" disabled>
                    Select Sub-Category
                  </option>
                  {/* Dynamically populate sub-categories */}
                  {selectedCategory &&
                    Array.isArray(selectedBot.ontology[selectedCategory])
                      ? selectedBot.ontology[selectedCategory].map((subCategory, index) => (
                          <option key={index} value={subCategory}>
                            {subCategory}
                          </option>
                        ))
                      : Object.keys(selectedBot.ontology[selectedCategory] || {}).map(
                          (subCategory) => (
                            <option key={subCategory} value={subCategory}>
                              {subCategory}
                            </option>
                          )
                        )}
                </select>
              </div>
            )}
         
           {/* <div id="ibook-thumb-div">
            {(() => {
              selectedBot = iBots
                .flatMap((group) => group.iBots)
                .find((bot) => bot.botid === assistantId);

                  // 🔹 Remove the existing `ibook-thumb` before rendering the new one
                    const thumbContainer = document.getElementById('ibook-thumb-div');
                    if (thumbContainer) {
                      const existingImage = document.getElementById('ibook-thumb');
                      if (existingImage && thumbContainer.contains(existingImage)) {
                        thumbContainer.removeChild(existingImage); // ✅ 
                      }
                    }
              if (selectedBot?.settings?.showThumb && selectedBot.thumbnail) {
                return (
                  <a href="/">
                    <img
                      id="ibook-thumb"
                      src={selectedBot.thumbnail}
                      alt="iBook Thumbnail"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </a>

                );
              }

              return null; // Render nothing if showThumb is false or no thumbnail exists
            })()}
          </div>
            */}
          <div
              className="cards-container"
              style={{
                backgroundColor: settings?.containerStyle?.backgroundColor || 'white'
              }}
            >

            <div className="cards">
              {selectedCategory && selectedSubCategory ? (
                selectedBot?.ontology &&
                selectedBot.ontology[selectedCategory] &&
                Array.isArray(selectedBot.ontology[selectedCategory][selectedSubCategory]) ? (
                  selectedBot.ontology[selectedCategory][selectedSubCategory].map((message, index) => (
                    <div
                      key={`preset-${index + 1}`}
                      className="card-white"
                      style={{ backgroundColor: settings?.buttonStyle?.backgroundColor || 'red' }}
                      onClick={() => {
                        const isNonEnglish = selectedBot?._currentLanguage && selectedBot._currentLanguage !== 'English';
                        const displayText = (message || '').toString().trim();
                        const originalText = (message || '').toString().trim(); // Ontology items don't have separate aiMessage yet, but logic is added for consistency

                        onPromptClicked?.(displayText);
                        localStorage.setItem("selectedPrompt", displayText);

                        const inputElement = document.getElementById('user-input');
                        if (inputElement) {
                          inputElement.value = displayText;
                        }

                        if (isNonEnglish) {
                          sendTextQuery(displayText, originalText);
                        } else {
                          sendTextQuery(originalText);
                        }
                        onUserQuestion?.(originalText, { fromPrompt: true });
                      }}
                    >
                    <span className="prompt-text">
                      {message.includes("\n") ? (
                        <>
                          <strong className='prompt-head' style={{ fontStyle: "bold", fontSize: "1.3em"}}>{message.split("\n")[0]}</strong> {/* First line in bold */}
                          <br />
                          <span className ='prompt-subhead' style={{ fontStyle: "italic", fontSize: "1.0em"}}>
                            {message.split("\n")[1]} {/* Second line italicized */}
                          </span>
                        </>
                      ) : (
                        <strong>{message}</strong> 
                      )}
                    </span>

                    </div>
                  ))
                ) : (
                  // Fallback if either ontology is missing or sub-category isn't an array
                  <div>No sub-category array found to map over.</div>
                )
              ) : (
                // Existing else logic if no category/subcategory is selected
                [...Array(PROMPT_BUTTON_MAX)].map((_, index) => {
                  const presetNumber = index + 1;
                  const presetMessage = selectedBot?.presets?.[`${presetNumber}`] || '';
                  const buttonText = presetMessage || `Preset ${presetNumber}`;
                  const iconDef = selectedBot?.iconSet?.[`${presetNumber}`];
                  const Icon =
                    iconDef && (HeroSolid[iconDef.name] || HeroOutline[iconDef.name]) || null;

                  return (
                    <div// With HeroIcons
                      key={`preset-${presetNumber}`}
                        className="card"
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          textAlign: 'left'
                        }}
                        data-label={presetMessage}
                        onClick={() => {
                          onPromptClicked?.(presetMessage);
                          const inputElement = document.getElementById("user-input");
                          if (inputElement) {
                            inputElement.value = presetMessage;
                          }
                          const cleanMessage = (presetMessage || '').toString().trim();
                          sendTextQuery(presetMessage);
                          onUserQuestion?.(cleanMessage, { fromPrompt: true });
                        }}
                      >
                        {Icon && (
                          <Icon
                            style={{
                              width: '30px',
                              height: '30px',
                              color: iconDef.color,
                              flexShrink: 0,
                            }}
                            aria-label={iconDef.label}
                          />
                        )}
                        <span
                          className="prompt-text"
                          style={{
                            display: 'inline-block',
                            textAlign: 'left',
                            lineHeight: '1.25',
                            verticalAlign: 'middle'
                          }}
                        >
                          {presetMessage.includes("\n") ? (
                            <>
                              <strong  className='prompt-head' style={{ fontStyle: "bold", fontSize: "1.3em"}}>{presetMessage.split("\n")[0]}</strong>
                              <br />
                              <span className='prompt-subHead' style={{ fontStyle: "italic", fontSize: "1.0em" }}>
                                {presetMessage.split("\n")[1]}
                              </span>
                            </>
                          ) : (
                            <strong>{buttonText}</strong>
                          )}
                        </span>
                      </div>
                  );
                })
              )}
            </div>
          </div>

          {/* END CARDS CONTAINER */}

          {/* 1. control table begin */}
          <div className="copy-button-container">
            <div className="control-row">
              <div className="welcome-text" id="welcome-text">
                {selectedBot?.welcome || 'Ask me a question.'}
              </div>
              <div
                className="control-buttons"
                style={{
                  display: "block",
                }}
              >
                {/*<button className="store-button" onClick={() => handleStoreChatHistory()} title="Store Chat History">
                  <img src={storeIconWhite} alt="Store" className="toolbar-image" />
                </button>*/}
                <button
                  className="copy-button"
                  data-label="Copy conversation"
                  onClick={() => copyConversationContent()}
                  title="Copy to Clipboard"
                    style={{
                      display:
                        selectedBotSettings?.containerStyle.copyContentButton === "true" 
                          ? "block"
                          : "none"
                    }}
                  >
                  <img src={copyIconWhite} alt="copy" className="toolbar-image" data-label="Copy conversation icon" />
                </button>

                <button
                  className="clear-session-button"
                  data-label="Clear conversation"
                  onClick={() => { notifySessionCleared('user_stop'); clearSession?.(); }}
                  title="Clear Conversation"
                  style={{
                      display:
                        selectedBotSettings?.containerStyle.deleteContentButton === "true" 
                          ? "block"
                          : "none"
                    }}
                  >
                  <img src={trashIconWhite} alt="clear" className="toolbar-image" data-label="Clear conversation icon" />
                </button>
                <button
                  className="email-content-button"
                  data-label="Email conversation"
                  onClick={() => openEmailModal()}
                  title="Send Email"
                  style={{
                    display:
                      selectedBotSettings?.containerStyle.emailContentButton === "true"
                        ? "block"
                        : "none",
                    border: "none",
                    background: "none",
                    textAlign: "center",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <img src={emailIconWhite} alt="email" className="toolbar-image" data-label="Email Button" />
                    
                    <span style={{ fontSize: "0.75rem", color: "white", marginTop: "4px" }}>
                      {selectedBotSettings.botid === "asst_SRqG7nOQ8boguG6EeEPkpNlE" || selectedBotSettings.botid  === "asst_k6gkeaM6VZsbvOjfBNt6BFrK" ? "EMAIL SUSAN" : "EMAIL"}
                    </span>

                  </div>
                </button>

              </div>

            </div>
          </div>

          {/*Video Avatar */}
          {/*
          <div id="video-container" className="video-container">
              {selectedBot?.settings?.showAvatar ? (
                  selectedBot?.avatar ? (
                      <video muted loop id="circle-video">
                          <source src={selectedBot.avatar} type="video/mp4" />
                          Your browser does not support the video tag.
                      </video>
                  ) : (
                      <p>No avatar video available</p>
                  )
              ) : (
                  <StarFormation videoContainerRef={videoContainerRef} />
              )}
          </div>*/}
        
    {/* control table end  */}


    {/* conversation begin */} 
    <div id="conversation" className="conversation resizable" style={{ pointerEvents: 'none', opacity: 0.5 }}>
      {items
        .filter(item => {
          const text = item.formatted?.text?.trim().toLowerCase();
          const isPing = text === '...';
          const isDot = text === '.';

          let captureNameFlag = false
          //NOTE this is DEPR
          const isStandbyAssistantMessage =
            item.role === 'assistant' &&
            (
              text.includes('standing by') ||
              text.includes("let me know when you're ready") ||
              text.includes("we can continue whenever you're") ||
              text.includes("take your time, i'm right here") ||
              text.includes('great to see you') ||
              text.includes("here whenever you're ready to continue.") ||
              text.includes("i'm still here") ||
              text.includes('just a reminder')
            );

      try {
         const chat1 = document.getElementById(`chat-text-item-1`)?.textContent?.trim() || '';

        if (chat1.includes("please tell me your name")) {        
          captureNameFlag = true
        }
  
        const chat2 =  document.getElementById(`chat-text-item-2`)?.textContent?.trim() || '';
 
        
        if (captureNameFlag === true && chat2 !== "") {
        let userReply = document.getElementById(`chat-text-item-2`)?.textContent ||"";// It's always item 2 (third chat item)

         
          // Parse Phrases
          if (
            userReply.includes("My name is") ||
            userReply.includes("I'm called") ||
            userReply.includes("You can call me") ||
            userReply.includes("It's") ||
            userReply.includes("I'm")
          ) {
            userReply = userReply
              .replace("My name is", "")
              .replace("I'm called", "")
              .replace("You can call me", "")
              .replace("It's", "")
              .replace("I'm", "")
              .trim();
            console.log("Filtered name:", userReply);
          }
        
          if (userReply) {
              //console.log("[USERNAME DETECTED] →", userReply);
              userInLineName = userReply 
              captureNameFlag = false;
              }
            }
          
      } catch (err) {
        console.error("Error parsing user name from conversation", err);
     }

      return !isPing && !isDot && !isStandbyAssistantMessage;
      })

         //[Conversation Data] - Define     
        .map((item, index) => {
        let rawText = item.formatted?.text || item.formatted?.transcript || '';

        // 🔹 River islands Patch Normalize assistant spelling - Dell'Osso and Lathrop
        rawText = rawText
          .replace(/\bLay-thrup\b/g, "Lathrop")
          .replace(/\bLaythrup\b/g, "Lathrop")
          .replace(/\bDell-oh-zoh\b/g, "Dell'Osso")
          .replace(/\bDelosso\b/g, "Dell'Osso");

        const formattedText = formatLinks(rawText);

         // [Media] - define
        const mediaKeys = selectedBot?.media ? Object.keys(selectedBot.media) : [];
        const matchedMediaKey = mediaKeys.find(key =>
          rawText && rawText.toLowerCase().includes(key.toLowerCase())
        );

        let matchedMediaData = null;
        let mediaAttributes = {};
        let mediaElement = null;

        /*HEY
        const parseMetadata = (metadataString = '') => {
          const attributes = {};
          metadataString.split(/\s+/).forEach((attr) => {
            const [key, value] = attr.split('=');
            if (key && value) {
              attributes[key.replace(/['"]/g, '')] = value.replace(/['"]/g, '');
            }
          });
          return attributes;
        };*/
        const parseMetadata = (metadataString = '') => {
          const attributes = {};
          const pairs = [];
          let current = '';
          let inQuotes = false;
          let quoteChar = null;

          for (let i = 0; i < metadataString.length; i++) {
            const char = metadataString[i];
            
            if ((char === '"' || char === "'") && (i === 0 || metadataString[i - 1] !== '\\')) {
              if (!inQuotes) {
                inQuotes = true;
                quoteChar = char;
              } else if (char === quoteChar) {
                inQuotes = false;
                quoteChar = null;
              }
            }
            
            if (char === ';' && !inQuotes) {
              if (current.trim()) pairs.push(current.trim());
              current = '';
            } else {
              current += char;
            }
          }
          
          if (current.trim()) pairs.push(current.trim());

          pairs.forEach((pair) => {
            const [key, ...rest] = pair.split('=');
            if (!key || !rest.length) return;
            const value = rest.join('=');
            attributes[key.trim()] = value.trim().replace(/^['"]|['"]$/g, '');
          });

          return attributes;
        };


        if (matchedMediaKey) {
          matchedMediaData = selectedBot.media[matchedMediaKey];
          mediaAttributes = matchedMediaData?.metadata
            ? parseMetadata(matchedMediaData.metadata)
            : {};      
          //console.debug('✅ [Media] Data found', mediaAttributes);
        }
        
        // Selected Bot Define
        const botName = selectedBot?.name ? `${selectedBot.name}: ` : "Agent";
        let userName = "You";
        if (user) {
          userName = user?.firstname 
            ? `${user.firstname[0].toUpperCase()}${user.firstname.slice(1)}: `
            : "You: ";
        }

        const textColor =
          item.role === 'assistant'
            ? 'purple'
            : item.role === 'user' && item.formatted?.text
            ? 'green'
            : 'blue';

        const prefix = item.role === 'assistant'
          ? botName
          : item.role === 'user'
          ? userName
          : '';

       
          /* [Media] - Begin */
        const parseStyleString = (styleString = '') => {// parse smediaType image and video style string into an object
          const style = {};
          styleString.split(';').forEach((rule) => {
            const [key, value] = rule.split(':');
            if (key && value) {
              style[key.trim()] = value.trim();
            }
          });
          return style;
        };
        
       if (matchedMediaData) {
          const mediaKeySanitized = matchedMediaKey.replace(/\s+/g, '-');

          // ✅ Prevent duplicates: skip if already rendered
            //if (renderedMediaKeys.has(mediaKeySanitized)) {
              //console.warn(`⚠️ Skipping duplicate render of: ${mediaKeySanitized}`);
              //mediaElement = null;  // ✅ Ensure no stale media renders
            //} else {
              const mediaSrc = matchedMediaData.url || matchedMediaData.src;
              console.log('✅ [Media] Source URL:', mediaSrc);
              if (!mediaSrc) {
                console.warn(`⚠️ No valid media source for key: ${matchedMediaKey}`, matchedMediaData);
              } else {
                const mediaType = matchedMediaData.type || 'image';
                const parsedStyle = parseStyleString(mediaAttributes.style);


              switch (mediaType) {
                case 'email': {
                  requestAnimationFrame(() => {
                    // Find the last chat-text-item by ID pattern
                    const all = document.querySelectorAll('[id^="chat-text-item-"]');
                    if (!all.length) return;

                    // Extract the highest index
                    const last = Array.from(all).reduce((prev, el) => {
                      const id = el.id || '';
                      const match = id.match(/chat-text-item-(\d+)/);
                      if (!match) return prev;
                      const idx = parseInt(match[1], 10);
                      const prevIdx = parseInt(prev?.id?.match(/chat-text-item-(\d+)/)?.[1] || '-1', 10);
                      return idx > prevIdx ? el : prev;
                    });

                    if (!last) return;
                
                    // Create wrapper
                    const wrapper = document.createElement('div');
                    wrapper.id = 'ri-email-button-last';
                    wrapper.style.textAlign = 'left';
                    wrapper.style.marginTop = '0.5em';

                    // Create button element (target01)
                    const button = document.createElement('button');
                    button.className = 'email-content-button';
                    button.title = 'Send Email';
                    button.onclick = () => openEmailModal();

                    const img = document.createElement('img');
                    img.src = emailIconBlack;
                    img.alt = 'email';
                    img.className = 'toolbar-image';

                    button.appendChild(img);
                    wrapper.appendChild(button);

                    // Insert after the last chat-text-item
                    last.insertAdjacentElement('afterend', wrapper);
                  });

                  // Don’t render inline
                  mediaElement = null;
                }
                break;
               
                case 'pdf': {
                  const pdfTitle = mediaAttributes.title || 'PDF Document';
                  const pdfStyle = {
                    width: mediaAttributes.width || '88vw',
                    height: mediaAttributes.height || '75vh',
                    border: '1px solid #ccc',
                    display: 'block',
                    marginTop: '1em',
                    ...parsedStyle,
                  };

                  const params = new URLSearchParams();
                  if (mediaAttributes.thumbnails === 'true') params.append('view', 'FitH');
                  if (mediaAttributes.showSidebar === 'true') params.append('sidebar', '1');
                  if (mediaAttributes.showToolbar === 'true') params.append('toolbar', '1');

                  const fullSrc = `${mediaSrc}#${params.toString()}`;

                  mediaElement = (
                    <iframe
                      id={`pdf-viewer`}
                      key={`media-${mediaKeySanitized}`}
                      src={fullSrc}
                      style={pdfStyle}
                      title={pdfTitle}
                    />
                  );
                  break;
                }

                //Update 12-12-25 - link multiple types
                case 'link': {
                  requestAnimationFrame(() => {
                    const all = document.querySelectorAll('[id^="chat-text-item-"]');
                    if (!all.length) return;

                    const last = Array.from(all).reduce((prev, el) => {
                      const match = el.id.match(/chat-text-item-(\d+)/);
                      if (!match) return prev;
                      const idx = parseInt(match[1], 10);
                      const prevIdx = parseInt(prev?.id?.match(/chat-text-item-(\d+)/)?.[1] || '-1', 10);
                      return idx > prevIdx ? el : prev;
                    });

                    if (!last) return;

                    // ✅ Unique per message + media key (prevents duplicates but allows reuse later)
                    const containerId = `ri-link-container-${mediaKeySanitized}-${index}`;

                    // ✅ If this link for this message already exists, don't inject again
                    if (document.getElementById(containerId)) return;

                    const linkTitle = mediaAttributes?.title || 'Visit link';
                    const linkStyle = mediaAttributes?.style || '';

                    const wrapper = document.createElement('div');
                    wrapper.id = containerId;
                    wrapper.style.textAlign = 'left';
                    wrapper.style.marginTop = '0.5em';

                    const a = document.createElement('a');
                    a.href = mediaSrc;
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                    a.textContent = linkTitle;

                    if (linkStyle) {
                      linkStyle.split(';').forEach(rule => {
                        const [prop, val] = rule.split(':');
                        if (prop && val) a.style[prop.trim()] = val.trim();
                      });
                    }

                    wrapper.appendChild(a);
                    last.insertAdjacentElement('afterend', wrapper);
                  });

                  mediaElement = null;
                  break;
                }




                case 'image': {
                  requestAnimationFrame(() => {
                    const all = document.querySelectorAll('[id^="chat-text-item-"]');
                    if (!all.length) return;

                    // Grab the last chat message
                    const last = Array.from(all).reduce((prev, el) => {
                      const match = el.id.match(/chat-text-item-(\d+)/);
                      if (!match) return prev;
                      const idx = parseInt(match[1], 10);
                      const prevIdx = parseInt(prev?.id?.match(/chat-text-item-(\d+)/)?.[1] || '-1', 10);
                      return idx > prevIdx ? el : prev;
                    });

                    if (!last) return;

                    if (document.getElementById('ri-image-container-last')) return;

                    const wrapper = document.createElement('div');
                    wrapper.id = 'ri-image-container-last';
                    wrapper.style.textAlign = 'left';
                    wrapper.style.marginTop = '0.5em';

                    const img = document.createElement('img');
                    img.src = mediaSrc;
                    img.alt = mediaAttributes.alt || '';
                    Object.assign(img.style, {
                      ...parsedStyle,
                      maxWidth: mediaAttributes.width || '88vw',
                      height: mediaAttributes.height || 'auto',
                      display: 'block',
                    });

                    wrapper.appendChild(img);
                    last.insertAdjacentElement('afterend', wrapper);
                  });

                  mediaElement = null;
                  break;
                }

                case 'video':
                 // console.log('📀 Match Media to Video');
                  const videoPoster = mediaAttributes['data-thumbnail'] || '';

                 
                  mediaElement = (
                    <a
                      id={`video-link`}
                      key={`media-${mediaKeySanitized}`}
                      href={mediaSrc}
                      target='_blank'
                      rel="noopener noreferrer"
                      style={{
                        border: '1px solid blue',
                        display: 'inline-block',
                        position: 'relative'
                      }}
                    >
                      <video
                        src={mediaSrc}
                        poster={videoPoster}
                        style={{
                          maxWidth: mediaAttributes.width || '88vw',
                          height: mediaAttributes.height || 'auto',
                          display: 'block',
                        }}
                        playsInline
                        loop
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '60px',
                          height: '60px',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pointerEvents: 'none'
                        }}
                      >
                      </div>
                    </a>
                  );

                  break;

                  case 'embed':
                  console.log('🎥 Embeded Video: Forcing Button Click Detection');
          
                  mediaElement = (
                    <div style={{ display: 'inline-block', height: mediaAttributes.height || '34vh' }}>
                      <video
                      id='video-embed'
                        src={mediaSrc}
                        style={{
                          width: '100%',
                          height: mediaAttributes.height || '34vh',
                          display: 'block',
                          backgroundColor: '#fff',   

                        }}
                        preload="auto"
                        playsInline
                        controls  // Native controls enabled
                        onClick={() => handleStopClick(clientRef.current)} // 🚨 stop fired only on click
                      />
                    </div>
                  );
                  break;



                default:
                  console.warn(`⚠️ Unsupported media type: ${mediaType}`);
              }

              //renderedMediaKeys.add(mediaKeySanitized); // ✅ Mark key as rendered
            }
          //}
        }
        //console.log('✅ [Media]', mediaElement);
        
        /* [Media] - end */
        
        // ✅ *** [Chat] [Media] Text element with clean multiline pattern without introducing unwanted spaces or <br>
        const mixedElement = (
        <div
          key={`text-${index}`}
          style={{ color: textColor }}
          dangerouslySetInnerHTML={{
            __html: (
              `<div id='media-container' style="display: ${mediaElement ? 'block' : 'none'}; text-align: center">` +
                `${mediaElement ? ReactDOMServer.renderToStaticMarkup(mediaElement) : ''}` +
              `</div><div class='chat-text-item' id='chat-text-item-${index}-div' style="display: flex; align-items: flex-start; gap: 0.5em;" >` +
              `<strong class='chat-role-item' id='chat-role-item-${index}' style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 25vw; flex-shrink: 0;">${prefix}</strong>` +
              `<div class='chat-text-item' id='chat-text-item-${index}'>${formattedText.replace(/\n/g, '</div><br /></div>'
              )}`
            ),
          }}
        ></div>
      );

       //return mixedElement;

       

       return (
        <>
          {mixedElement}
          {/*<span id={`tracker-${index}`} data-index={index} style={{ display: 'none' }}></span>*/}
        </>
      );
      
      })}
    </div>
    {/* conversation end */}
      
    {/* 2. text input and input controls table begin */}
    <div id="input-area" className="input-area" style={{backgroundColor:"#000", borderRadius:"5%"}}>
    
    <table className="input-table">
      <tbody>
        <tr className="input-row" style={{ height: "9vh" }}>
          
          {/* Toggle Voice Button */}
          <td className="input-table-cell">
            <button
              id="toggle-voice"
              title="Tap to speak, Tap again to send"
              className={`microphone commandbar-image ${isRecording ? 'recording' : ''}`}
              onClick={() => {
                if (isRecording) {
                  stopRecording();
                } else {
                  startRecording();
                }
              }}
              disabled={
                !iBots
                  .flatMap((group) => group.iBots)
                  .find((bot) => bot.botid === assistantId)?.endpoint.includes('realtime')
              }
            >
              <img
                src={isRecording ? micIconRed : micIconWhite}
                alt="Microphone"
                className="microphone-image commandbar-image"
              />
            </button>
          </td>

          {/* Mute Voice Button */}
          <td className="input-table-cell">
              <button
                id="stop-voice"
                className="submit-btn"
              title="Press to STOP speech"
              data-name="stop-speech-button"
                onClick={() => {
                  if (typeof toggleMute === 'function') {
                    toggleMute();
                  } else {
                    handleStopClick(clientRef.current);
                  }
                }}
              >
                <img
                  className="input-area commandbar-image"
                  src={stopButtonIcon}
                  alt="Stop Speech"
                  data-name="Stop Button"
                />
              </button>
          </td>

          {/* User Input Textarea */}
          <td className="input-textarea-cell">
            <textarea
              id="user-input"
              ref={userInputRef}
              placeholder="Type mewssage here, then click '⏎' to send "
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  const inputElement = e.target;
                  const userInput = inputElement.value.trim();
                  if (userInput) {
                    if (!tryHandleVideoModalMedia(userInput)) {
                      onUserQuestion?.(userInput);
                      setItems((prevItems) => [
                        ...prevItems,
                        { role: 'user', formatted: { text: userInput } },
                      ]);
                      clientRef.current.sendUserMessageContent([
                        { type: 'input_text', text: userInput },
                      ]);
                    }
                    inputElement.value = '';
                  }
                }
              }}
            ></textarea>
          </td>

          {/* Submit Text Button */}
          <td className="input-table-cell">
            <button
              id="submit-text"
              title="Click to send Text"
              className="submit-btn commandbar-image"
              onClick={() => {
                const inputElement = document.getElementById('user-input');
                const userInput = inputElement.value.trim();
                if (userInput) {
                  if (!tryHandleVideoModalMedia(userInput)) {
                    onUserQuestion?.(userInput);
                    setItems((prevItems) => [
                      ...prevItems,
                      { role: 'user', formatted: { text: userInput } },
                    ]);
                    clientRef.current.sendUserMessageContent([
                      { type: 'input_text', text: userInput },
                    ]);
                  }
                  inputElement.value = '';
                }
              }}
            >
              <img
                id="text-enter"
                className="input-area commandbar-image"
                src={enterIconWhite}
                alt="Enter Text"
              />
            </button>
          </td>

        </tr>
      </tbody>
    </table>


  </div>

      
      {/* 2. input controls end */}
      
      
      {/* 3. content visuals begin */}
      {/*
      <div id="content-visuals" className="content-visuals">
          <div className="visualization">
             
              <canvas id="client-sound-wave" ref={clientCanvasRef} className="sound-wave"></canvas>

              <div id="video-container" className="video-container">
                  {selectedBot?.settings?.showAvatar ? (
                      selectedBot?.avatar ? (
                          <video muted loop id="circle-video">
                              <source src={selectedBot.avatar} type="video/mp4" />
                              Your browser does not support the video tag.
                          </video>
                      ) : (
                          <p>No avatar video available</p>
                      )
                  ) : (
                      <StarFormation videoContainerRef={videoContainerRef} />
                  )}
              </div>

              
              <canvas id="server-sound-wave" ref={serverCanvasRef} className="sound-wave"></canvas>
          </div>
      </div>
      */}
      {/* content visuals end */}
          
        {/* email modal */}
        {showEmailModal && (
          <div className="email-modal-overlay">
            <form id='email-form'>
            <div className="email-modal">
              <button className="email-modal-close" onClick={handleEmailCloseModal}>&times;</button>
              <h2 className="email-modal-title">Email Conversation</h2>
             
              <div className="email-row">
                <span>To:</span>
                <div className="email-text">{selectedBotSettings.integration.EmailConfig.to_name}</div>
              </div>
              <div className="email-row">
                <span>From:</span>
                <div className="email-text">{selectedBotSettings.integration.EmailConfig.from_name}</div>
                
            </div>
            
            <div id='email-user'>
            <label htmlFor="emailFromName">Your Name</label>
            <input
                type="text"
                placeholder="Enter your name"
                defaultValue={(user?.firstname?.trim() || "")}
                id="emailFromName"
                onChange={(e) => setEmailFromName(e.target.value)}
                required
              />

              <label htmlFor="emailFrom">Your Email:</label>
              <input
                type="email"
                placeholder="Verify or Enter your email"
                defaultValue={user.email}
                id="emailFrom"
                onChange={(e) => setEmailFrom(e.target.value)}
                required
              />
              </div>

              
              <label
               htmlFor="emailSubject">Subject:</label>
              <input
                type="text"
                placeholder="Subject:"
                defaultValue={emailSubject}
                id="emailSubject"
                onChange={(e) => setEmailSubject(e.target.value)}
                required
              />

             <div id="emailLabel" style={{ fontSize: "0.85rem" }}>Body:</div>
              <div
              id="emailBody"
              className="conversation resizable"
              contentEditable={false}
              suppressContentEditableWarning={true}
              style={{ fontSize: "0.85rem" }}
              ref={(el) => {
                // EMAIL HANDLER  — run once to prevent re-build each render
                if (!el || el.dataset.initialized === "true") return;
                el.dataset.initialized = "true";

                const toMsg = selectedBotSettings?.integration?.EmailConfig?.emailMessage?.message || "";
                const source = document.getElementById("conversation");
                if (!source) return;

                const clone = source.cloneNode(true);

                const firstDiv = clone.querySelector("div:nth-child(1)");
                if (firstDiv) firstDiv.remove();
                const secondDiv = clone.querySelector("div:nth-child(1)");
                if (secondDiv) secondDiv.remove();

                const container = document.createElement("div");

                const header = document.createElement("div");
                header.innerText = toMsg;
                header.style.whiteSpace = "pre-wrap";
                header.style.marginBottom = "1em";

                const messageSection = document.createElement("div");
                const messageHeader = document.createElement("div");
                messageHeader.innerText = "Your message:";
                messageHeader.style.fontWeight = "bold";
                messageHeader.style.marginBottom = "0.5em";

                const messageBox = document.createElement("div");
                messageBox.contentEditable = "true";
                messageBox.style.width = "100%";
                messageBox.style.minHeight = "3em";
                messageBox.style.border = "1px solid #ccc";
                messageBox.style.padding = "6px";
                messageBox.style.marginBottom = "1.5em";
                messageBox.style.borderRadius = "4px";

   

                /* 🧠 preserve edits — store locally so re-renders keep text
                 messageBox.addEventListener("input", () => {
                 localStorage.setItem("draftEmailMessage", messageBox.innerText);
                //});

                const saved = localStorage.getItem("draftEmailMessage");
                if (saved) messageBox.innerText = saved;
                */
                // Add User footer to email - User name and Email:
                /*
                const userFooter = document.createElement("div");
                const emailFromName = document.getElementById("emailFromName").value;
                const emailFrom = document.getElementById("emailFrom").value;

                userFooter.style.marginTop = "1em";
                userFooter.style.fontSize = "0.85em";
                userFooter.style.color = "#555";
                userFooter.innerHTML = `<br/>
                  <strong>Sender:</strong> ${emailFromName}<br/>
                  <strong>Email:</strong>  ${emailFrom}
                `;
                
                messageSection.appendChild(userFooter);
                */
                messageSection.appendChild(messageHeader);
                messageSection.appendChild(messageBox);
                
                
                const transcriptHeader = document.createElement("div");
                transcriptHeader.innerText = "Transcript:";
                transcriptHeader.style.fontWeight = "bold";
                transcriptHeader.style.marginBottom = "0.5em";

                container.appendChild(header);
                container.appendChild(messageSection);
                container.appendChild(transcriptHeader);
                container.appendChild(clone);

                el.innerHTML = "";
                el.appendChild(container);
              }}
            />


              
             
              {emailErrorMessage && <p className="email-error-message">{emailErrorMessage}</p>}
              
              <div className="email-modal-actions">
                <button type="button" className="email-modal-cancel" onClick={handleEmailCloseModal}>Cancel</button>
                <button type="button" className="email-modal-send" onClick={sendEmailContent}>Send Email</button>
              </div>

              <div className="email-modal-footer">
                <a
                  className="email-modal-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://laurie7912.wixsite.com/ribusinesspark/privacy-policy"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </form>
        </div>
      )}  
        
       
       { /* controls */ }
           
          <div id="buttons-container" className="buttons-container" style={{display:"none"}}>
            <button
              id="loadThreads"
              className="load-threads"
              onClick={() => {
                const threadsLog = document.getElementById("threads-log");

                if (threadsLog.style.display === "none") {
                  threadsLog.style.display = "block";
                  document.getElementById("loadThreads").innerText = "Hide Threads";
                  
                  // Load threads if not already loaded
                  if (!threads || threads.length === 0) {
                    //handleLoadThreads();
                  }
                } else {
                  threadsLog.style.display = "none";
                  document.getElementById("loadThreads").innerText = "Load Threads";
                }
              }}
            >
              Load History
            </button>

            <button
              onClick={() => setShowEventsLog((prev) => !prev)}
              className="toggle-events-log"
            >
              {showEventsLog ? "Hide Events" : "Show Events"}
            </button>
          </div>
          

          {/* Threads Log (Below Buttons) */}
          <div id="threads-log" style={{ display: "block" }}>
            {loading && (
              <div style={{ color: "red", fontSize: "0.9em", fontWeight: "bold" }}>
                🔄 Fetching Conversation History...
              </div>
            )}
            {error && (
              <div style={{ color: "red", fontSize: "0.9em" }}>
                ⚠️ Error loading threads: <br />
                <span style={{ fontStyle: "italic" }}>{error}</span>
              </div>
            )}
             <pre id="threads-span">
              {threads
                ? JSON.stringify(
                    Object.values(
                      threads.reduce((grouped, thread) => {
                        const threadId = thread.thread_id || 'unknown-session';

                        if (!grouped[threadId]) {
                          grouped[threadId] = {
                            thread_id: threadId,
                            messages: [],
                          };
                        }

                        const rawText = thread.formatted?.text || thread.formatted?.transcript || '';
                        const text = rawText.trim().toLowerCase();

                        const isPing = text === '...';
                        const isDot = text === '.';
                        const isStop = text === 'stop';

                        const isStandby = // DEPR - Not implemented
                          text.includes('standing by') ||
                          text.includes("let me know when you\'re ready") ||
                          text.includes("we can continue whenever you\'re") ||
                          text.includes("take your time, i\'m right here") ||
                          text.includes('great to see you') ||
                          text.includes('great to have you here') ||
                          text.includes("i\'m here whenever you\'re ready to continue.") ||
                          text.includes("i\'m still here") ||
                          text.includes('just a reminder');

                        if (rawText && !isPing && !isDot && !isStop && !isStandby) {
                          grouped[threadId].messages.push(thread);
                        }

                        return grouped;
                      }, {})
                    ),
                    null,
                    2
                  )
                : ""}
            </pre>



          </div>

          {/* Events Log (Below Buttons) - Full Log
                  {Array.isArray(realtimeEvents)
          ? realtimeEvents.map((event, index) => (
              <pre id="event-span" key={index}>{JSON.stringify(event, null, 2)}</pre>
            ))
          : null}
          */}
          
          {/* Filtered Log - Speech */}
          <div
            ref={eventsScrollRef}
            className="events-log"
            id="events-log"
            style={{ display: showEventsLog ? "block" : "none" }}// or none
          >
            {Array.isArray(realtimeEvents)
            ? realtimeEvents
                .filter((event) => {
                  const item = event?.event?.item;
                  const content = item?.content;
                  if (!item || !Array.isArray(content)) return false;

                  return {
                    userId: user.id,
                    orgId: user.org.orgId,
                    runId: localStorage.getItem('currentRunId'),
                    threadId: localStorage.getItem('currentThreadId'),
                    assistantId: assistantId,
                    match:
                      (item.role === "user" && content[0]?.type === "input_text") ||
                      (item.role === "assistant" && item.status === "completed" && content[0]?.type === "audio"),
                  };
                  
                })
                .map((event, index) => (
                  <pre id="event-span" key={index}>{JSON.stringify(event, null, 2)}</pre>
                ))
            : null}

          </div>
                
         {/* controls end */}

        </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

ChatUIWhite.defaultProps = {
  botSettings: null,
  emitStandbyLine: () => {},
  toggleMute: () => {},
  isMuted: false,
};

export default ChatUIWhite;
